import api from 'api/client';
import { ENDPOINTS } from 'api/endpoints';
import { PriceList } from 'types/storefront';

type CatalogConfigApi = {
  priceLists?: Array<{ id?: string; name?: string; code?: string }>;
  PriceLists?: Array<{ Id?: string; Name?: string }>;
};

const priceListService = {
  getPriceLists: async (): Promise<PriceList[]> => {
    const response = await api.get<CatalogConfigApi>(ENDPOINTS.CATALOG_CONFIG);
    const raw = response.data.priceLists || response.data.PriceLists || [];
    return raw.map((item) => {
      const id = String((item as { id?: string; Id?: string }).id || (item as { Id?: string }).Id || '').trim();
      const name = String(
        (item as { name?: string; Name?: string }).name || (item as { Name?: string }).Name || id
      ).trim();
      return { id, name, code: id };
    });
  },
};

export default priceListService;
